<p-panel class="col-12" *ngIf="!TVResume">
  <p-header>
    <div class="grid col-12 p-0">
      <div class="col">
        <app-races-info [selectedRace]="selectedRace"></app-races-info>
      </div>
      <div class="col-fixed" style="width: 350px">
        <div class="p-inputgroup">
          <div class="p-inputgroup-addon">
            <span class="label">
              {{ appSettings.translate[selectedLang]["time_state"] }}
            </span>
          </div>
          <app-time-state-selector [time_state]="time_state"
            (time_stateUpdate)="timeStateChange($event)"></app-time-state-selector>
        </div>
      </div>
      <div class="col-fixed" style="width: 200px">
        <app-class-selector [selectedRace]="selectedRace" [raceClasses]="raceClasses" [selectedClass]="selectedClass"
          (refresh)="refresh($event)"></app-class-selector>
      </div>
      <div class="col-fixed" style="width: 100px">
        <p-inputSwitch [(ngModel)]="minimize"></p-inputSwitch>
      </div>
    </div>
  </p-header>
  <div class="grid">
    <div class="p-inputgroup" *ngIf="selectedRace.isOrg">
      <div class="p-inputgroup-addon">
        <span class="label">
          {{ appSettings.translate[selectedLang]["edit_mode"] }}
        </span>
      </div>
      <p-inputSwitch [(ngModel)]="modeEdit" class="inputgroup-input"></p-inputSwitch>
    </div>
    <div class="grid col-12">
      <button class="col-12" type="button" (click)="newVersion()" pButton
        [label]="appSettings.translate[selectedLang]['newVersion']"></button>
    </div>
  </div>
</p-panel>

<div class="col-12 p-0 layout-content">
  <div class="col-12 p-0" *ngIf="raceProgress">
    <div *ngFor="let section of [].constructor(sections); index as i" #section attr.id="section_{{i}}">
      <app-progress-table [scrollableCols]="scrollableCols" [sections]="sections" [i]="i" [TVResume]="TVResume"
        [selectedRace]="selectedRace" [selectedLang]="selectedLang" [modeEdit]="modeEdit"
        [selectedClass]="selectedClass" [checkHeight]="checkHeight" [time_state]="time_state"
        [classes]="raceProgress.classes" (refresh)="refreshGet()" (openInfoEvent)="clickInfo($event)"
        [minimize]="minimize"></app-progress-table>
    </div>
  </div>
  <div>
    <div class="annotation dsq_1">
      {{ appSettings.translate[selectedLang]["lapInvalid"] }}
    </div>
    <div class="annotation dsq_0">
      {{ appSettings.translate[selectedLang]["lapValid"] }}
    </div>
    <div class="annotation best_lap">
      {{ appSettings.translate[selectedLang]["bestLap"] }}
    </div>
    <div class="annotation joker">
      {{ appSettings.translate[selectedLang]["joker"] }}
    </div>
    <div class="annotation obligatory">
      {{ appSettings.translate[selectedLang]["optionalLap"] }}
    </div>
    <div class="annotation manualEdit">
      {{ appSettings.translate[selectedLang]["editedLap"] }}
    </div>
    <div class="annotation timebar">
      {{ appSettings.translate[selectedLang]["timebar"] }}
    </div>
    <div class="annotation" style="float: right" *ngIf="TVResume">
      обновлено {{ lastDateUpdate | date : "HH:mm:ss" }}
    </div>
    <div style="float: right" *ngIf="!TVResume && raceProgress">
      <button type="button" (click)="progressService.csv(raceProgress)" pButton icon="pi pi-save"
        label="{{ appSettings.translate[selectedLang]['exportCSV'] }}"></button>
    </div>
  </div>
</div>